import { LOGIN_URL } from '@/constants/environment';

export function redirectToLogin(): void {
  const currentURL = window.location.href;

  window.location.href = `${LOGIN_URL}?redirect=${encodeURIComponent(currentURL)}`;
}
